import { render } from "./loader.vue?vue&type=template&id=27f8348a"
const script = {}

import "./loader.vue?vue&type=style&index=0&id=27f8348a&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__